<template>
  <div class="">
    <div class="title">厂家直发</div>
    <div class="di"></div>
    <div class="product">
      <div class="side">
        <van-sidebar v-model="activeKey">
          <van-sidebar-item
            v-for="v in names"
            :key="v.id"
            :title="v.name"
            @click='side(v.id)'
          />
        </van-sidebar>
      </div>

      <div class="content">
        <ul>
          <li
            class="clearfix"
            v-for="v in list "
            :key="v.id"
            @click="goproud(v.id)"
          >
            <img
              :src="v.thumb"
              alt=""
            >
            <p class="name">{{v.name}}</p>
            <p class="price">￥{{v.min_price}}</p>
          </li>
        </ul>
      </div>
    </div>
    <van-tabbar
      active-color="#950f0f"
      route
    >
      <van-tabbar-item
        to="/"
        info=""
      >
        <span style="font-size:0.32rem">首页</span>

        <img
          slot="icon"
          src="../assets/footbar/2-02.png"
          style="width:0.55rem;height:0.55rem"
        />
      </van-tabbar-item>
      <van-tabbar-item
        to="/class"
        info=""
      >
        <span style="font-size:0.32rem">产品分类</span>
        <img
          slot="icon"
          src="../assets/footbar/3-02.png"
          style="width:0.55rem;height:0.55rem"
        />
      </van-tabbar-item>
      <van-tabbar-item
        to="/manufactures"
        info=""
      >
        <span style="font-size:0.32rem">厂家直发</span>
        <img
          slot="icon"
          src="../assets/footbar/44-02.png"
          style="width:0.65rem;height:0.55rem"
        />
      </van-tabbar-item>
      <van-tabbar-item
        to="/car"
        info=""
      >
        <span style="font-size:0.32rem">购物车</span>
        <img
          slot="icon"
          src="../assets/footbar/5-02.png"
          style="width:0.6rem;height:0.55rem"
        />
      </van-tabbar-item>
      <van-tabbar-item
        to="/my"
        info=""
      >
        <span style="font-size:0.32rem">我的</span>
        <img
          slot="icon"
          src="../assets/footbar/1-02.png"
          style="width:0.6rem;height:0.55rem"
        />
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import Vue from 'vue'
import { Search, Tab, Tabs, Icon, Tabbar, TabbarItem, Sidebar, SidebarItem } from 'vant'
Vue.use(Search)
  .use(Tab)
  .use(Tabs)
  .use(Icon)
  .use(Tabbar)
  .use(TabbarItem)
  .use(SidebarItem)
  .use(Sidebar)
export default {
  created () {
    this.axios.get('getFactoryTwoClass', { params: { store_id: this.$store.state.shopid } }).then(res => {
      this.names = res.data.data
      this.axios.get('getGoodsList', { params: { store_id: this.$store.state.shopid, class_id: res.data.data[0].id } }).then(res1 => {

        this.list = res1.data.data
      }).catch(ref => { })
    }).catch(ref => { })
  },
  data () {
    return {
      activeKey: 0,
      names: [],
      list: []
    }
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    side (v) {
      this.axios.get('getGoodsList', { params: { store_id: this.$store.state.shopid, class_id: v } }).then(res1 => {

        this.list = res1.data.data
      }).catch(ref => { })
    },
    goproud (id) {
      this.$router.push({ name: 'product', query: { id, c: 1 } })
    },
    golist () {
      this.$router.push({ name: 'productList', params: { id: 1 } })

    }
  }
}
</script>
<style lang="less" scoped>
.title {
  font-size: 0.426667rem;
  height: 1.333333rem;
  text-align: center;
  line-height: 1.3333rem;
}
.di {
  // background-color: #f7f7f7;
  height: 0.3rem;
}
.product {
  padding-bottom: 1rem;
  display: flex;
  .side {
    .van-sidebar {
      // width: 1.333333rem;
    }
    .van-sidebar-item {
      background-color: #f7f7f7;
      color: #333;
    }
    .van-sidebar-item--select {
      // background-color: #ee0a24;
    }
  }
  .content {
    flex: 1;
    .title {
      text-align: center;
      font-size: 0.4rem;
      height: 1rem;
    }
    ul {
      li {
        // float: left;
        // width: 45%;
        // padding: 0.266667rem 0.01rem 0.1rem 0.533333rem;
        // padding-left: 0.1rem;
        // padding-right: 0.1rem;
        // margin-left: 0.1rem;
        margin: 0.2rem 0 0.5rem 0.2rem;
        img {
          width: 2.666667rem;
          float: left;
          margin-right: 0.2rem;
        }
        .price {
          height: 0.9rem;
          line-height: 0.9rem;
          font-size: 0.4rem;
          color: #a22d2b;
        }
        .name {
          font-size: 0.373333rem;
          color: #333;
        }
      }
    }
  }
}
</style>